import Favorite from 'assets/icons/Favorite';
import React, { useEffect, useState } from 'react';

import SimpleSwitch from './SimpleSwitch';

const OfferSwitch = ({ setIsFavoriteParam, labelActive, labelInactive }) => {
  const [showFavorites, setShowFavorites] = useState(false);

  const toggleFavorites = () => {
    setShowFavorites((prev) => !prev);
  };

  useEffect(() => {
    if (showFavorites === true) {
      setIsFavoriteParam(true);
    } else {
      setIsFavoriteParam(null);
    }
  }, [showFavorites]);

  return (
    <div className='flex items-center gap-1'>
      <SimpleSwitch isActive={showFavorites} onToggle={toggleFavorites} />
      <Favorite color={showFavorites ? '#F16347' : 'rgb(180, 180, 180)'} />
    </div>
  );
};

export default OfferSwitch;
